/**
 * #show_form.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { messageTypeRegistry } from "../../../../typeRegistry.js";
import { Form } from "../../form_builder/v1alpha/form.js";
import { FormFieldValue } from "../../form_builder/v1alpha/value.js";
function createBaseShowFormEffect() {
    return { form: undefined };
}
export const ShowFormEffect = {
    $type: "devvit.ui.effect_types.v1alpha.ShowFormEffect",
    encode(message, writer = _m0.Writer.create()) {
        if (message.form !== undefined) {
            Form.encode(message.form, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseShowFormEffect();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.form = Form.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { form: isSet(object.form) ? Form.fromJSON(object.form) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.form !== undefined) {
            obj.form = Form.toJSON(message.form);
        }
        return obj;
    },
    create(base) {
        return ShowFormEffect.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseShowFormEffect();
        message.form = (object.form !== undefined && object.form !== null) ? Form.fromPartial(object.form) : undefined;
        return message;
    },
};
messageTypeRegistry.set(ShowFormEffect.$type, ShowFormEffect);
function createBaseFormSubmittedEvent() {
    return { results: {}, formId: undefined };
}
export const FormSubmittedEvent = {
    $type: "devvit.ui.effect_types.v1alpha.FormSubmittedEvent",
    encode(message, writer = _m0.Writer.create()) {
        Object.entries(message.results).forEach(([key, value]) => {
            FormSubmittedEvent_ResultsEntry.encode({ key: key, value }, writer.uint32(10).fork()).ldelim();
        });
        if (message.formId !== undefined) {
            writer.uint32(18).string(message.formId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFormSubmittedEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    const entry1 = FormSubmittedEvent_ResultsEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.results[entry1.key] = entry1.value;
                    }
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.formId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            results: isObject(object.results)
                ? Object.entries(object.results).reduce((acc, [key, value]) => {
                    acc[key] = FormFieldValue.fromJSON(value);
                    return acc;
                }, {})
                : {},
            formId: isSet(object.formId) ? globalThis.String(object.formId) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.results) {
            const entries = Object.entries(message.results);
            if (entries.length > 0) {
                obj.results = {};
                entries.forEach(([k, v]) => {
                    obj.results[k] = FormFieldValue.toJSON(v);
                });
            }
        }
        if (message.formId !== undefined) {
            obj.formId = message.formId;
        }
        return obj;
    },
    create(base) {
        return FormSubmittedEvent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFormSubmittedEvent();
        message.results = Object.entries(object.results ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = FormFieldValue.fromPartial(value);
            }
            return acc;
        }, {});
        message.formId = object.formId ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(FormSubmittedEvent.$type, FormSubmittedEvent);
function createBaseFormSubmittedEvent_ResultsEntry() {
    return { key: "", value: undefined };
}
export const FormSubmittedEvent_ResultsEntry = {
    $type: "devvit.ui.effect_types.v1alpha.FormSubmittedEvent.ResultsEntry",
    encode(message, writer = _m0.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            FormFieldValue.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFormSubmittedEvent_ResultsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = FormFieldValue.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? FormFieldValue.fromJSON(object.value) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== undefined) {
            obj.value = FormFieldValue.toJSON(message.value);
        }
        return obj;
    },
    create(base) {
        return FormSubmittedEvent_ResultsEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFormSubmittedEvent_ResultsEntry();
        message.key = object.key ?? "";
        message.value = (object.value !== undefined && object.value !== null)
            ? FormFieldValue.fromPartial(object.value)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(FormSubmittedEvent_ResultsEntry.$type, FormSubmittedEvent_ResultsEntry);
function createBaseFormCanceledEvent() {
    return { formId: undefined };
}
export const FormCanceledEvent = {
    $type: "devvit.ui.effect_types.v1alpha.FormCanceledEvent",
    encode(message, writer = _m0.Writer.create()) {
        if (message.formId !== undefined) {
            writer.uint32(10).string(message.formId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFormCanceledEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.formId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { formId: isSet(object.formId) ? globalThis.String(object.formId) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.formId !== undefined) {
            obj.formId = message.formId;
        }
        return obj;
    },
    create(base) {
        return FormCanceledEvent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFormCanceledEvent();
        message.formId = object.formId ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(FormCanceledEvent.$type, FormCanceledEvent);
function isObject(value) {
    return typeof value === "object" && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
